<template>
  <div class="row d-flex flex-row h-100">
    <auth-left-container> </auth-left-container>
    <div
      class="right-container bg-extra-light-gray p-4 d-flex flex-column justify-content-center align-items-center text-black"
    >
      <div class="center-form">
        <h2 class="mb-4" style="font-weight: bold;">
          Create your <span class="text-primary">New Password</span>
        </h2>
        <form class="form-action" @submit.prevent="resetPassword">
          <b-form-group
            :invalid-feedback="formErrors.password.join(', ')"
            :state="formErrors.password.length == 0 ? null : false"
            style="margin-top: 35px;"
          >
            <vue-password
              v-model="password"
              placeholder="Enter new password"
              :disableStrength="true"
              class="bigger-input"
            />
          </b-form-group>
          <b-form-group
            :invalid-feedback="formErrors.confirmPassword.join(', ')"
            :state="formErrors.confirmPassword.length == 0 ? null : false"
            style="margin-top: 35px;"
          >
            <vue-password
              v-model="confirmPassword"
              placeholder="Re-type new password"
              :disableStrength="true"
              class="bigger-input"
            />
          </b-form-group>
          <b-button
            type="submit"
            variant="primary"
            class="auth-button w-100"
            style="margin-top: 20px;"
          >
            Confirm Password
          </b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VuePassword from "vue-password";
import serverAuth from "../../server/auth";
import { validateRequired } from "../../helpers/validation";
import AuthLeftContainer from "./AuthLeftContainer.vue";

export default {
  name: "AuthResetPassword",
  components: {
    AuthLeftContainer,
    VuePassword
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      code: this.$route.params.code,
      formErrors: {
        password: [],
        confirmPassword: []
      }
    };
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async resetPassword() {
      if (this.validateSubmit()) {
        const authResult = await serverAuth.resetPassword(this.code, {
          password: this.password,
          confirmation: this.confirmPassword
        });

        if (authResult.errorCode) {
          this.formErrors.confirmPassword.push(authResult.message);
        } else {
          this.showAlertSuccess();
          this.$router.push("/login");
        }
      }
    },
    validateSubmit() {
      this.formErrors.password = [];
      this.formErrors.confirmPassword = [];

      let withoutErrors = true;

      if (!validateRequired(this.password)) {
        this.formErrors.password.push("This field is required");
        withoutErrors = false;
      } else if (this.password.length < 8) {
        this.formErrors.password.push(
          "The password must be at least 8 characters long"
        );
        withoutErrors = false;
      }

      if (!validateRequired(this.confirmPassword)) {
        this.formErrors.confirmPassword.push("This field is required");
        withoutErrors = false;
      } else if (this.confirmPassword != this.password) {
        this.formErrors.confirmPassword.push("Passwords do not match");
        withoutErrors = false;
      }

      return withoutErrors;
    }
  }
};
</script>
<style scoped>
.right-container {
  width: 50%;
}
.center-form {
  padding: 0px 15%;
}
.form-action {
  max-width: 400px;
  min-width: 400px;
}
</style>
